import React from "react";
import { Link } from "react-router-dom";
import { vendorLabel, VENDOR_SLUGS } from "../lib/api";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-white/10 mt-32 bg-[#0A0A0C]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="font-serif italic text-3xl">ayush.resellz</div>
          <p className="mt-4 text-white/50 max-w-md text-sm leading-relaxed">
            A curated reseller of premium electronics, Dyson, Ray-Ban Meta, sneakers, fragrance,
            jewelry, accessories, and designer apparel. Every piece verified. Shipped fast.
          </p>
        </div>
        <div>
          <div className="overline mb-4">Shop</div>
          <ul className="space-y-2 text-white/70 text-sm">
            {VENDOR_SLUGS.map((s) => (
              <li key={s}>
                <Link to={`/c/${s}`} data-testid={`footer-${s}`} className="hover:text-white">
                  {vendorLabel(s)}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="overline mb-4">Contact</div>
          <ul className="space-y-2 text-white/70 text-sm">
            <li>
              <a
                href="https://tiktok.com/@ayush.resellz"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-tiktok"
                className="hover:text-white"
              >
                tiktok.com/@ayush.resellz
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex items-center justify-between text-xs uppercase tracking-[0.22em] text-white/40">
          <span>© {new Date().getFullYear()} ayush.resellz</span>
          <span>Curated · Verified · Shipped</span>
        </div>
      </div>
    </footer>
  );
}
